import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  CardWrapper,
  ContentWrapper,
  Title,
  Description,
  SwitchWrapper
} from './SimpleCard.styled';

import { StyledSwitch } from '../../Section/Marketing/Tabs/AdvancedSettings.styled';

const SimpleCard = ({
  title,
  description,
  checked = false,
  onChange,
  value,
  disabled = false,
  className = ''
}) => {
  const [isActive, setIsActive] = useState(checked);

  useEffect(() => {
    setIsActive(checked);
  }, [checked]);

  return (
    <CardWrapper className={className} isActive={isActive}>
      <SwitchWrapper>
        <FormControlLabel
          control={
            <StyledSwitch
              checked={checked}
              onChange={onChange}
              value={value}
              disabled={disabled}
            />
          }
        />
      </SwitchWrapper>
      <ContentWrapper>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </ContentWrapper>
    </CardWrapper>
  );
};
export default SimpleCard;
